import VoerroTagsInput from './VoerroTagsInput.vue'

window.VoerroTagsInput = VoerroTagsInput;

export default VoerroTagsInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@voerro/vue-tagsinput/src/main.js
// module id = Hs2t
// module chunks = 1